import { createContext, useContext } from 'react';

export const ModelVersionsContext = createContext<CF.API.Models.ModelVersion[] | null>(null);

export const useModelVersionsContext = (): CF.API.Models.ModelVersion[] => {
  const context = useContext<CF.API.Models.ModelVersion[] | null>(ModelVersionsContext);
  if (context === null) {
    throw new Error('useModelVersionsContext() must be used within a ModelVersionsContextProvider');
  }
  return context;
};
